import { ProtocolPdfBeService } from './protocol-pdf-be.service';
import { ProtocolPdfConstants } from './protocol-pdf.constants';
import { ProtocolPdfDto } from 'src/app/dtos/protocolPdfDto';

export class ProtocolPdfBeEmailService extends ProtocolPdfBeService {
  protected addSignatureBlock(protocolPdfDto: ProtocolPdfDto, baseY: number): number {
    const multiLineTextResponsiblePersonPresent = this.getMultiLineText(
      ProtocolPdfConstants.defaultFontSize,
      ProtocolPdfConstants.defaultFontType,
      this.translateService.instant('ProtocolPdf.TextResponsiblePersonPresentBeEmail'),
      ProtocolPdfConstants.maxLineWidth,
    );
    const signatureBlockHeight =
      multiLineTextResponsiblePersonPresent.length + 3 * ProtocolPdfConstants.lineHeight;
    if (baseY + signatureBlockHeight > ProtocolPdfConstants.maxYValue) {
      baseY = this.newPage();
    }
    baseY += ProtocolPdfConstants.lineHeight;
    baseY = this.writeMultiLineText(
      multiLineTextResponsiblePersonPresent,
      ProtocolPdfConstants.defaultFontSize,
      ProtocolPdfConstants.defaultFontType,
      ProtocolPdfConstants.marginX,
      baseY,
      0,
    );
    baseY += ProtocolPdfConstants.lineHeight;
    const emailText = this.getEmailAddressToProtocolPdf(protocolPdfDto);
    const emailMarginX = ProtocolPdfConstants.marginX + 35;
    baseY = this.writeMultiLineText(
      [emailText],
      ProtocolPdfConstants.defaultFontSize,
      ProtocolPdfConstants.boldFontType,
      emailMarginX,
      baseY,
      0,
    );
    const textWidth = this.pdfDocument.getTextWidth(emailText);
    this.addUnderline(emailMarginX, baseY + 1, textWidth);
    baseY += ProtocolPdfConstants.lineHeight;
    return baseY;
  }
}
